import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCsrfToken } from "../utils/csrfToken.js";

// The server only requires a CSRF token for mutating requests -- attaching
// it to GET queries too would add an unnecessary fetch on first load and
// could fail read-only queries if /api/csrf-token is briefly unavailable.
export const prepareHeaders = async (
    headers: Headers,
    { type }: { type: string }
): Promise<Headers> => {
    if (type === "mutation") {
        headers.set("x-csrf-token", await getCsrfToken());
    }
    return headers;
};

export interface ContactInformation {
    email: string;
    mobilePhone: string;
}

export const API = createApi({
    reducerPath: "API",
    tagTypes: ["ContactInformation"],
    baseQuery: fetchBaseQuery({
        baseUrl: "/api/",
        prepareHeaders,
    }),
    endpoints: (builder) => ({
        auth: builder.mutation({
            query: (opts) => ({
                url: "auth",
                body: opts,
                method: "POST",
            }),
        }),
        getCard: builder.query({
            query: () => ({
                url: "member/id",
            }),
        }),
        getMembers: builder.query({
            query: (opts) => ({
                url: "member",
                params: opts,
            }),
        }),
        getPlans: builder.query({
            query: (opts) => ({
                url: "member/plan",
                params: opts,
            }),
        }),
        getContactInformation: builder.query<ContactInformation, void>({
            query: () => ({
                url: "member/preferences",
            }),
            providesTags: ["ContactInformation"],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetCardQuery,
    useAuthMutation,
    useGetMembersQuery,
    useGetPlansQuery,
    useGetContactInformationQuery,
} = API;
